import { Edit, SimpleForm, TextInput, DateTimeInput, SelectInput } from 'react-admin';

const TRANSACTION_TYPES = [
  { id: 'Journal', name: 'Journal' },
  { id: 'Invoice', name: 'Invoice' },
  { id: 'Receipt', name: 'Receipt' },
  { id: 'Refund', name: 'Refund' },
  { id: 'Allocation', name: 'Allocation' },
  { id: 'OpeningBalance', name: 'Opening Balance' },
  { id: 'ClosingBalance', name: 'Closing Balance' },
];

const TRANSACTION_STATUS = [
  { id: 'Pending', name: 'Pending' },
  { id: 'Posted', name: 'Posted' },
  { id: 'Voided', name: 'Voided' },
  { id: 'Reversed', name: 'Reversed' },
];

export const TransactionEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="transactionNumber" label="Transaction Number" fullWidth />
      <SelectInput source="transactionType" choices={TRANSACTION_TYPES} fullWidth />
      <DateTimeInput source="transactionDate" fullWidth />
      <SelectInput source="status" choices={TRANSACTION_STATUS} fullWidth />
      <TextInput source="description" fullWidth />
      <TextInput source="reference" fullWidth />
      <TextInput source="sourceDocument" label="Source Document" fullWidth />
    </SimpleForm>
  </Edit>
);
